
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class DayRangePicker extends Vue {
    @Prop({ type: Array, required: true }) readonly periods!: any[];
    @Prop({ type: Array, required: true }) readonly months!: any[];

    @Prop({ type: Number, required: true }) readonly valueYear!: number;
    @Prop({ type: Number, required: true }) readonly valueMonth!: number;

    @Prop({ type: Number, default: null }) readonly type!: number | null;

    internalYear: number = 0;
    internalMonth: number = 1;
    internalRange: number[] = [1, 1];

    get daysInThisMonth(): number {
        return new Date(this.internalYear, this.internalMonth, 0).getDate();
    }

    mounted() {
        this.internalYear = this.valueYear;
        this.internalMonth = this.valueMonth;

        this.setFullMonthRange();
        this.$nextTick(() => {
            this.emitDayRange();
            this.emitYearMonth();
        });
    }

    onYearChange() {
        this.setFullMonthRange();
        this.emitYearMonth();
    }

    onMonthChange() {
        this.setFullMonthRange();
        this.emitYearMonth();
    }

    setFullMonthRange() {
        const maxDay = this.daysInThisMonth;
        this.internalRange = [1, maxDay];
        this.emitDayRange();
    }

    emitYearMonth() {
        this.$emit('update-year', this.internalYear);
        this.$emit('update-month', this.internalMonth);
    }

    emitDayRange() {
        const [start, end] = this.internalRange;
        this.$emit('update:day-range', { start, end });
    }
}
